<div class="balance-container">
  <div class="balance-card">
    <div class="header">
      <h2>Saldo Payall</h2>
      <button class="refresh-btn" (click)="refreshData()" title="Actualizar">
        <i class="fas fa-sync-alt"></i>
      </button>
    </div>
    
    <div *ngIf="loading" class="loading">
      <div class="spinner"></div>
    </div>

    <div *ngIf="error" class="error-message">
      {{ error }}
      <button class="btn btn-primary" (click)="loadBalance()">
        Reintentar
      </button>
    </div>

    <div *ngIf="!loading && !error" class="balance-amount">
      <span class="currency">Bs.</span>
      <span class="amount">{{ balance | number:'1.2-2' }}</span>
    </div>

    <div class="last-transactions" *ngIf="!loading && !error">
      <h3>Últimas Transacciones</h3>
      <div class="transaction-list">
        <div *ngFor="let transaction of lastTransactions" class="transaction-item">
          <div class="transaction-info">
            <span class="transaction-type">{{ transaction.tipo }}</span>
            <span class="transaction-date">{{ formatDate(transaction.fecha) }}</span>
          </div>
          <span class="transaction-amount" [ngClass]="{'credit': transaction.tipo === 'CRÉDITO', 'debit': transaction.tipo === 'DÉBITO'}">
            {{ transaction.monto | number:'1.2-2' }} Bs.
          </span>
        </div>
      </div>

      <button class="btn btn-primary history-button" (click)="toggleHistory()">
        {{ showHistory ? 'Ocultar Historial' : 'Ver Historial Completo' }}
      </button>

      <div *ngIf="showHistory" class="full-history">
        <div *ngIf="historyLoading" class="loading">
          <div class="spinner"></div>
        </div>
        
        <div *ngIf="!historyLoading" class="transaction-list">
          <div *ngFor="let transaction of fullHistory" class="transaction-item">
            <div class="transaction-info">
              <span class="transaction-type">{{ transaction.tipo }}</span>
              <span class="transaction-date">{{ formatDate(transaction.fecha) }}</span>
            </div>
            <span class="transaction-amount" [ngClass]="{'credit': transaction.tipo === 'CRÉDITO', 'debit': transaction.tipo === 'DÉBITO'}">
              {{ transaction.monto | number:'1.2-2' }} Bs.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 